class HamburgerMenu {
  constructor(configuration) {
    const { toggleButton, content} = configuration;
    this.content = content;
    toggleButton.addEventListener('change', this.toggleButtonHandler.bind(this));
  }

  /**
   * toggleButtonHandler: Handles when the toggle button checked changes.
   * @param {Event} event Change event related to the hamburger menu toggle button.
   */
  toggleButtonHandler(event) {
    if (!event.target.checked) {
      const accordionMenuToggles = this.content.querySelectorAll('[data-menu-accordion-toggle]');
      accordionMenuToggles.forEach(menuToggle => {
        menuToggle.checked = false;
      });
    }

    // emit a custom event when the menu is opened
    const customEvent = new CustomEvent('hamburgerMenuClicked', {
      detail: { data: {
          isOpen: event.target.checked
      } }
  });
    document.body.dispatchEvent(customEvent);
  }
}

export default HamburgerMenu;